import script from "./MenuBottom.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuBottom.vue?vue&type=script&lang=ts&setup=true"

import "./MenuBottom.vue?vue&type=style&index=0&id=d44dc69a&lang=css"

const __exports__ = script;

export default __exports__